@file:OptIn(InternalResourceApi::class)

package mobile_wallet.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mobile_wallet.core.ui.generated.resources/"

public val Res.drawable.arrow_outward: DrawableResource by lazy {
      DrawableResource("drawable:arrow_outward", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_outward.xml", -1, -1),
      ))
    }

public val Res.drawable.artwork: DrawableResource by lazy {
      DrawableResource("drawable:artwork", setOf(
        ResourceItem(setOf(), "${MD}drawable/artwork.xml", -1, -1),
      ))
    }

public val Res.drawable.core_ui_info_outline: DrawableResource by lazy {
      DrawableResource("drawable:core_ui_info_outline", setOf(
        ResourceItem(setOf(), "${MD}drawable/core_ui_info_outline.xml", -1, -1),
      ))
    }

public val Res.drawable.core_ui_money_in: DrawableResource by lazy {
      DrawableResource("drawable:core_ui_money_in", setOf(
        ResourceItem(setOf(), "${MD}drawable/core_ui_money_in.png", -1, -1),
      ))
    }

public val Res.drawable.core_ui_money_out: DrawableResource by lazy {
      DrawableResource("drawable:core_ui_money_out", setOf(
        ResourceItem(setOf(), "${MD}drawable/core_ui_money_out.png", -1, -1),
      ))
    }

public val Res.drawable.feature_receipt_mifospay_round_logo: DrawableResource by lazy {
      DrawableResource("drawable:feature_receipt_mifospay_round_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_receipt_mifospay_round_logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("arrow_outward", Res.drawable.arrow_outward)
  map.put("artwork", Res.drawable.artwork)
  map.put("core_ui_info_outline", Res.drawable.core_ui_info_outline)
  map.put("core_ui_money_in", Res.drawable.core_ui_money_in)
  map.put("core_ui_money_out", Res.drawable.core_ui_money_out)
  map.put("feature_receipt_mifospay_round_logo", Res.drawable.feature_receipt_mifospay_round_logo)
}
